import { Search } from '@/lib/icons'

const DisabledSearchBar = () => {
    return (
        <button
            name='Search'
            type='button'
            aria-label='Search'
            className="text-xl sm:text-sm fixed bottom-2 left-2 md:bottom-0 md:left-0 md:relative flex-center gap-2 px-3 sm:px-4 py-3 sm:py-2 bg-light/5 backdrop-blur-sm border border-light/20 rounded-full cursor-text hover:brightness-110 transition-colors duration-200"
        >
            <Search className="text-light/50 mt-0.5" />
            <span className="hidden sm:block text-light/60 mt-0.5 text-sm" > Search </span>
            <kbd className="ml-auto hidden lg:inline-flex items-center mt-0.5 px-2 py-1 bg-light/10 rounded text-xs text-light/50" >
                ctrl + k
            </kbd>
        </button>
    )
}

export default DisabledSearchBar